import './Tabs.scss'

import React, { Component } from 'react'
import cx from 'bem-classnames';
import { Link } from 'react-router'

class Tabs extends Component {

    render() {
        let classes = {
            name: 'Tabs',
            modifiers: ['type']
        }

        let skipRouter = this.props.skipRouter

        function isActive(tabValue, urlValue) {
            return tabValue === urlValue
        }

        const tabs = React.Children.map(this.props.children, (tab) => {
            return tab ? React.cloneElement(tab, {
                active: this.props.isActive ? this.props.isActive(tab.props.value, this.props.value) : isActive(tab.props.value, this.props.value),
                skipRouter: skipRouter,
            }) : null
        })

        return (<ul className={cx(classes, this.props)}>
            { tabs }
        </ul>)
    }
}

class Tab extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        let classes = {
            name: 'Tabs__item',
            modifiers: ['active'],
        }

        let linkClasses = {
            name: 'Tabs__link',
            modifiers: ['active'],
        }

        const bugCount = this.props.bug || 0

        let link
        if (this.props.skipRouter) {
            link = (
            <Link to='#' className={cx(linkClasses, this.props)} onClick={(e) => this.props.onClick(e)}>
              {this.props.dataTestId || this.props.label}
            </Link>
          )
        } else if (this.props.outboundLocation) {
          link = (
            <a href={this.props.outboundLocation} target="_blank" rel="noopener noreferrer" className={cx(linkClasses, this.props)}>
              {this.props.label}
            </a>
          )
        } else {
          link = (
            <Link to={{pathname:this.props.value}} className={cx(linkClasses, this.props)} data-testid={this.props.dataTestId || this.props.label}>
              {this.props.label}
            </Link>
          )
        }

        let bugClass = bugCount !== 0 ? 'Tabs__bug' : ''


        return (<li className={cx(classes, this.props)}>{ link }<span className={bugClass}>{bugCount !== 0 ? bugCount : ''}</span></li>)
    }
}

export {Tabs, Tab}
